export const GET_CARD_TOKENIZATION_PAGE_START = 'GET_CARD_TOKENIZATION_PAGE_START';
export const GET_CARD_TOKENIZATION_PAGE_SUCCESS = 'GET_CARD_TOKENIZATION_PAGE_SUCCESS';
export const GET_CARD_TOKENIZATION_PAGE_FAIL = 'GET_CARD_TOKENIZATION_PAGE_FAIL';
export const TOKENIZE_CARD_START = 'TOKENIZE_CARD_START';
export const TOKENIZE_CARD_SUCCESS = 'TOKENIZE_CARD_SUCCESS';
export const TOKENIZE_CARD_FAIL = 'TOKENIZE_CARD_FAIL';
export const UPDATE_CARD_TOKENIZATION_PAGE = 'UPDATE_CARD_TOKENIZATION_PAGE';
export const SET_CARD_PAYMENT = 'SET_CARD_PAYMENT';
export const NOTIFY_CARD_TOKENIZATION_FAIL = 'NOTIFY_CARD_TOKENIZATION_FAIL';
